module.exports = __webpack_public_path__ + "fb330bdc154a92008e639bed84c86c99.MP3";